export const environment = {
	production: true,
	staging: false,
	googleApiKey: 'AIzaSyBqW3eoOlVa5S8CIPMb4wO48vnNWExrYCs',
	gtagId: 'UA-23654096-1',
	restApiDomain: 'https://www.worldwidemoving.co.uk',
	hotjarId: '889390',
	bingId: '26024121',
	bugsnagId: '033c6154c9ee21fa2d68b64cb624d0a8',
	zeroBounceApiKey: '42d2e12516a94bd9956138e915db061e'
};
